import WebLayout from "../../../layout/WebLayout";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../stores";
import RegistrationAction from "../../../stores/actions/registrationAction";
import { Link } from "react-router-dom";

function MyBuyerList() {
  const dispatch = useDispatch<any>();
  const [search, setSearch] = useState<any>();
  const [limit, setLimit] = useState<any>();
  const { myBuyerList } = useSelector(
    (state: RootState) => state.mangeRegistration
  );

  const getBSList = useCallback(async () => {
    await dispatch(
      RegistrationAction.getMyBuyerList({
        search: search,
        limit: limit,
      })
    );
  }, [dispatch, search, limit]);

  useEffect(() => {
    getBSList();
  }, [getBSList, search, limit]);

  return (
    <WebLayout pageName={"MyBuyerList"}>
      <div className="content-wrapper">
        <div className="container-fluid flex-grow-1 container-p-y">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent">
              <ul className="navbar-nav me-auto mb-lg-0">
                <li className="nav-item ">
                  <Link className="btn btn-success p-2 m-1" to="/my-buyer-list">
                    My Buyer List
                  </Link>
                </li>
                <li className="nav-item ">
                  <Link className="btn btn-warning p-2 m-1" to="/bs-list">
                    Others Buyer List
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
          <div className="card bg-success">
            <div className="card-header d-flex justify-content-between align-items-center pb-2">
              <h4 className="card-title text-white">BS List</h4>
            </div>
            <div className="table-responsive text-nowrap">
              <table className="table text-center table-bordered text-white">
                <thead>
                  <tr>
                    <th className="text-white">SN.</th>
                    <th className="text-white">Compnay Name</th>
                    <th className="text-white">Name</th>
                    <th className="text-white">Mobile</th>
                    <th className="text-white">Email</th>
                  </tr>
                </thead>
                <tbody>
                  {myBuyerList?.length > 0 ? (
                    myBuyerList.map((bs: any, index: number) => {
                      return (
                        <tr key={bs.id}>
                          <td>{index + 1}</td>
                          <td>{bs.name_of_entity}</td>
                          <td>{bs.rep_name}</td>
                          <td>{bs.mobile}</td>
                          <td>{bs.email}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={7}>No matching records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
}

export default MyBuyerList;
